import { useNavigate } from 'react-router-dom';
import { Container, Content, Header } from './styles';

interface PassatempoProps {
  id: number;
  texto: string;
  titulo: string;
  disponivel: boolean;
}

interface CardProps {
  passatempo: PassatempoProps;
  foto: string;
}

export const Card: React.FC<CardProps> = ({ passatempo, foto }: CardProps) => {
  const navigate = useNavigate();
  return (
    <Container
      isDisabled={!passatempo.disponivel}
      {...(passatempo.disponivel && {
        onClick: () => navigate(`/jogo/palavrascruzadas/${passatempo.id}`),
      })}
    >
      <Header>
        <p>{passatempo.id}</p>
      </Header>

      <Content>
        <span>
          <img src={foto} alt={`${passatempo.titulo} de ${passatempo.texto}`} />
        </span>

        <div>
          <span>
            <h1>{passatempo.titulo}</h1>
            <h2>{passatempo.texto}</h2>
          </span>
        </div>
      </Content>
    </Container>
  );
};
